import React, { Fragment, useState } from 'react';
import { useProductState } from '../store';

import { useTranslation } from 'react-i18next';
import Accordion from '@/components/v2/UI/Accordion';
import { SYMBOLS } from '@/helpers/symbolsMap';
import clsx from 'clsx';
import { filter, first, isEmpty, map } from 'lodash';
import Image from 'next/future/image';
import { IProductAwards } from '@/models';
import { Dialog, Transition } from '@headlessui/react';
import { XIcon } from '@heroicons/react/solid';

interface Props {
  award: IProductAwards;
}

const AwardReadMode: React.FC<Props> = ({ award }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  function toggleOpen() {
    setIsOpen(isOpen => !isOpen);
  }

  return (
    <Fragment>
      <a className="underline text-primary cursor-pointer" onClick={toggleOpen}>
        {t('READ_LESS')}
      </a>

      <Transition show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-20 overflow-y-auto"
          onClose={toggleOpen}
        >
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="transition-opacity duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black/30" />
            </Transition.Child>

            <Transition.Child
              as={Fragment}
              enter="transition-all ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="transition-all ease-in duration-300"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="w-full max-w-2xl bg-white shadow-xl rounded-lg overflow-hidden">
                <Dialog.Title className="flex justify-between items-center bg-gray-200 px-6 py-3">
                  <h3 className="text-2xl font-medium">{award.name}</h3>

                  <button
                    className="flex justify-center items-center w-8 h-8 bg-white rounded-full"
                    onClick={toggleOpen}
                  >
                    <XIcon className="w-4 h-4 text-primary" />
                  </button>
                </Dialog.Title>

                <div className="flex  flex-col md:flex-row items-center space-y-3 sm:p-6 sm:space-y-6 lg:space-y-0 lg:flex-row lg:space-x-6 overflow-y-auto">
                  {award.image && (
                    <div className="w-full overflow-y-auto py-3 sm:py-0 ">
                      <Image
                        src={award.image}
                        alt={award.name}
                        width={0}
                        height={0}
                        sizes="100vw"
                        className="sm:w-full h-52 w-auto sm:h-auto m-auto"
                      />
                    </div>
                  )}
                  {award.description && (
                    <div className="lg:text-sm text-xs space-y-2 p-4">
                      {award.description.split('\n').map((item, index) => (
                        <p key={index}>{item}</p>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </Fragment>
  );
};

export default AwardReadMode;
